<template>
  <div class="carousel__container">
    <div v-if="hasLeftScroll" :class="'icon-arrow icon-arrow--left'" @click="scroll('left')"></div>
    <div v-if="hasRightScroll" :class="'icon-arrow icon-arrow--right'" @click="scroll('right')"></div>
    <div class="carousel__slide" @scroll="checkScrolls()">
      <div :class="'carousel__date' + activeDayClass(day.date)" v-for="day in sliderDays" :key="day.day" @click="setDate(day, $event)">
        <p class="carousel__weekday">{{ day.weekday }}</p>
        <p class="carousel__day">{{ day.day }}</p>
      </div>
    </div>
    <FormulateInput
      type="date"
      name="needAttentionDay"
      ref="needAttentionDay"
      v-model="needAttentionDay"
      :validation="'bail|required|' + dateValidation"
      :validation-messages="{ required: 'El día es obligatorio.', after: 'El día no puede ser anterior al actual.' }"
      hidden
    />
  </div>
</template>

<script>
import moment from 'moment';
import { useCalendarUtils } from '@/funnels/utils/calendar';

const { days } = useCalendarUtils();

export default {
  props: {
    latestTimeToSchedule: {
      type: String,
    },
    day: {
      type: String,
    },
  },
  data() {
    return {
      needAttentionDay: null,
      hasLeftScroll: false,
      hasRightScroll: true,
    };
  },
  created() {
    this.needAttentionDay = this.day;
  },
  computed: {
    sliderDays() {
      return Array.from({ length: days() }, (x, i) => {
        const firstDate = this.isTimeOver ? moment().add(1, 'days') : moment();
        let date = firstDate
          .locale('es')
          .startOf('day')
          .add(i, 'days');

        return {
          date: date,
          day: date.date(),
          weekday:
            date
              .format('ddd')
              .charAt(0)
              .toUpperCase() + date.format('ddd').slice(1, -1),
        };
      });
    },
    dateValidation() {
      return (
        'after:' +
        moment()
          .subtract(1, 'days')
          .format('YYYY-MM-DD')
      );
    },
    isTimeOver() {
      return moment().format('HH:mm') >= this.latestTimeToSchedule;
    },
    indexOfSelectedDate() {
      return this.sliderDays.findIndex(day => day.day == moment(this.needAttentionDay, 'YYYY-MM-DD').format('D'));
    },
  },
  methods: {
    isCurrentDay(day) {
      return moment().format('YYYY-MM-DD') === day.format('YYYY-MM-DD');
    },
    checkScrolls() {
      const slide = document.getElementsByClassName('carousel__slide')[0];
      var maxScroll = slide.scrollWidth - slide.clientWidth;
      this.hasRightScroll = slide.scrollLeft < maxScroll;
      this.hasLeftScroll = slide.scrollLeft > 0;
    },
    scroll(side) {
      const slide = document.getElementsByClassName('carousel__slide')[0];
      if (side === 'right') {
        slide.scrollLeft += Math.ceil(slide.offsetWidth + days() + 1);
        this.setDate(this.sliderDays[this.indexOfSelectedDate + days() + 1]);
      } else {
        slide.scrollLeft -= Math.ceil(slide.offsetWidth + days() + 1);
        this.setDate(this.sliderDays[this.indexOfSelectedDate - days() + 1]);
      }
      this.checkScrolls();
    },
    setDate(day, event) {
      if (!!event) {
        const slide = document.getElementsByClassName('carousel__slide')[0];
        var element = event.target;
        if (!element.classList.contains('carousel__date')) element = event.target.parentElement;
        var position = element.getBoundingClientRect();
        var positionSlide = slide.getBoundingClientRect();

        if (position.left < positionSlide.left || position.right > positionSlide.right) {
          if (position.left < positionSlide.left) slide.scrollLeft -= Math.ceil(position.width);
          else slide.scrollLeft += Math.ceil(position.width);
        }
      }
      if (this.isCurrentDay(day.date) && this.isTimeOver) this.$refs.needAttentionDay.setErrors(['No quedan citas diponibles para hoy.']);
      else {
        this.$refs.needAttentionDay.setErrors(null);
        this.needAttentionDay = day.date.format('YYYY-MM-DD');
        this.$emit('input', this.needAttentionDay);
      }
    },
    activeDayClass(day) {
      return this.needAttentionDay == day.format('YYYY-MM-DD') ? ' carousel__date--active' : '';
    },
  },
};
</script>
